export const LOAD_NEIGHBORS = 'changeNode/CONECTION_LOAD_NEIGHBORS';
export const LOAD_NEIGHBORS_SUCCESS = 'changeNode/CONECTION_LOAD_NEIGHBORS_SUCCESS';
